(function () {
  function initNavigation(productNav) {
    if (productNav.dataset.srNavInitialized === 'true') return;
    productNav.dataset.srNavInitialized = 'true';
    const sectionLinks = Array.from(productNav.querySelectorAll('[data-sr-section-link]'));
    const controller = new AbortController();
    const signal = controller.signal;
    let sectionScrollFrame;

    function getTarget(link) {
      if (!link.getAttribute('href')?.startsWith('#')) return null;
      return document.getElementById(link.dataset.srSectionLink);
    }
    function getSectionOffset() { return productNav.getBoundingClientRect().height + 18; }
    function setActiveSection(activeLink) {
      sectionLinks.forEach(function (link) {
        const active = link === activeLink;
        link.classList.toggle('is-active', active);
        link.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }
    function updateActiveSection() {
      const targets = sectionLinks.map(function (link) {
        const target = getTarget(link);
        return target && target.getClientRects().length ? { link, top: target.getBoundingClientRect().top } : null;
      }).filter(Boolean).sort(function (a, b) { return a.top - b.top; });
      if (!targets.length) return;
      const offset = getSectionOffset();
      let active = targets[0];
      targets.forEach(function (target) { if (target.top <= offset + 1) active = target; });
      setActiveSection(active.link);
    }
    function queueActiveSectionUpdate() {
      if (sectionScrollFrame) return;
      sectionScrollFrame = window.requestAnimationFrame(function () { sectionScrollFrame = undefined; updateActiveSection(); });
    }
    window.addEventListener('scroll', queueActiveSectionUpdate, { passive: true, signal });
    window.addEventListener('resize', queueActiveSectionUpdate, { passive: true, signal });
    window.addEventListener('load', queueActiveSectionUpdate, { once: true, signal });
    document.addEventListener('shopify:section:load', queueActiveSectionUpdate, { signal });
    document.addEventListener('shopify:section:reorder', queueActiveSectionUpdate, { signal });
    document.addEventListener('shopify:section:unload', function (event) {
      if (!event.target.contains(productNav)) return;
      controller.abort();
      window.cancelAnimationFrame(sectionScrollFrame);
      delete productNav.dataset.srNavInitialized;
    }, { signal });
    sectionLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = getTarget(link);
        if (!target) return;
        event.preventDefault();
        const top = window.scrollY + target.getBoundingClientRect().top - getSectionOffset();
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        window.scrollTo({ top: Math.max(0, top), behavior });
        setActiveSection(link);
      }, { signal });
    });
    updateActiveSection();
  }

  function init(root) {
    if (root.dataset.srInitialized === 'true') return;
    root.dataset.srInitialized = 'true';
    document.documentElement.classList.add('lefy-soundrest-product-page');

    const $ = (selector) => root.querySelector(selector);
    const $$ = (selector) => Array.from(root.querySelectorAll(selector));
    const doc$ = (selector) => document.querySelector(selector);
    const doc$$ = (selector) => Array.from(document.querySelectorAll(selector));
    const thumbs = $$('[data-sr-gallery-thumb]');
    const mainImage = $('[data-sr-main-image]');
    const galleryMain = $('[data-sr-gallery-main]');
    const lightbox = $('[data-sr-lightbox]');
    const lightboxImage = $('[data-sr-lightbox-image]');
    let galleryIndex = 0;
    let toastTimer;

    function setGallery(index) {
      if (!thumbs.length || !mainImage) return;
      galleryIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[galleryIndex];
      galleryMain.classList.add('is-changing');
      window.setTimeout(function () {
        mainImage.src = thumb.dataset.srGallerySrc;
        mainImage.alt = thumb.dataset.srGalleryAlt || '';
        if (lightboxImage) {
          lightboxImage.src = thumb.dataset.srGallerySrc;
          lightboxImage.alt = thumb.dataset.srGalleryAlt || '';
        }
        galleryMain.classList.remove('is-changing');
      }, 120);
      const indexLabel = $('[data-sr-gallery-index]');
      if (indexLabel) indexLabel.textContent = String(galleryIndex + 1).padStart(2, '0');
      thumbs.forEach(function (item, itemIndex) {
        const active = itemIndex === galleryIndex;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { setGallery(Number(thumb.dataset.srGalleryThumb)); });
    });
    $('[data-sr-gallery-prev]')?.addEventListener('click', function () { setGallery(galleryIndex - 1); });
    $('[data-sr-gallery-next]')?.addEventListener('click', function () { setGallery(galleryIndex + 1); });

    const modeData = {};
    doc$$('[data-sr-story-mode]').forEach(function (button) {
      modeData[button.dataset.srStoryMode] = {
        image: button.dataset.srModeImage,
        copy: button.dataset.srModeCopy,
        index: Object.keys(modeData).length + 1
      };
    });
    doc$$('[data-sr-mode]').forEach(function (button) {
      if (!modeData[button.dataset.srMode]) {
        const storyButton = root.querySelector('[data-sr-story-mode="' + button.dataset.srMode + '"]');
        modeData[button.dataset.srMode] = { image: storyButton?.dataset.srModeImage || '', copy: storyButton?.dataset.srModeCopy || '', index: Object.keys(modeData).length + 1 };
      }
    });

    function setMode(mode, skipImage) {
      const data = modeData[mode];
      if (!data) return;
      doc$$('[data-sr-mode]').forEach(function (button) {
        const active = button.dataset.srMode === mode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      doc$$('[data-sr-story-mode]').forEach(function (button) {
        button.classList.toggle('is-active', button.dataset.srStoryMode === mode);
      });
      doc$('[data-sr-mode-label]')?.replaceChildren(document.createTextNode(mode));
      doc$('[data-sr-mode-title]')?.replaceChildren(document.createTextNode(mode));
      doc$('[data-sr-mode-copy]')?.replaceChildren(document.createTextNode(data.copy));
      const index = doc$('[data-sr-mode-index]');
      if (index) index.textContent = String(data.index).padStart(2, '0') + ' / 03';
      const image = doc$('[data-sr-mode-image]');
      if (image && data.image && !skipImage) {
        image.style.opacity = '0.15';
        window.setTimeout(function () { image.src = data.image; image.style.opacity = '1'; }, 130);
      }
    }

    doc$$('[data-sr-mode]').forEach(function (button) { button.addEventListener('click', function () { setMode(button.dataset.srMode); }); });
    doc$$('[data-sr-story-mode]').forEach(function (button) { button.addEventListener('click', function () { setMode(button.dataset.srStoryMode); }); });

    const quantityInput = $('[data-sr-quantity]');
    function changeQuantity(delta) {
      if (!quantityInput) return;
      const current = Number(quantityInput.value) || 1;
      quantityInput.value = Math.min(9, Math.max(1, current + delta));
    }
    $('[data-sr-quantity-decrease]')?.addEventListener('click', function () { changeQuantity(-1); });
    $('[data-sr-quantity-increase]')?.addEventListener('click', function () { changeQuantity(1); });

    const variantSelect = $('[data-sr-variant-select]');
    const variantPrice = $('[data-sr-product-price]');
    const mobilePrice = $('[data-sr-mobile-price]');
    const variantButton = $('[data-sr-add-to-cart]');
    variantSelect?.addEventListener('change', function () {
      const selected = variantSelect.options[variantSelect.selectedIndex];
      const available = selected?.dataset.available === 'true';
      if (variantPrice && selected?.dataset.price) variantPrice.textContent = selected.dataset.price;
      if (mobilePrice && selected?.dataset.price) mobilePrice.textContent = selected.dataset.price;
      if (variantButton) {
        variantButton.disabled = !available;
        const label = variantButton.querySelector('span');
        variantButton.childNodes[0].textContent = available ? 'Add to cart' : 'Sold out';
        if (label) variantButton.appendChild(label);
      }
    });

    const toast = $('[data-sr-cart-toast]');
    function showToast(message, error) {
      if (!toast) return;
      const messageNode = $('[data-sr-toast-message]');
      if (messageNode) messageNode.textContent = message;
      toast.classList.toggle('is-error', Boolean(error));
      toast.classList.add('is-visible');
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () { toast.classList.remove('is-visible'); }, 4200);
    }
    $('[data-sr-toast-close]')?.addEventListener('click', function () { toast?.classList.remove('is-visible'); });

    const productForm = $('.sr-product-form');
    async function addToCart(event) {
      if (event) event.preventDefault();
      if (!productForm) return;
      const submitButton = $('[data-sr-add-to-cart]');
      if (submitButton?.disabled) return;
      submitButton?.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(root.dataset.cartAddUrl || '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(productForm)
        });
        if (!response.ok) throw new Error('cart_add_failed');
        showToast('SoundRest added to your bag', false);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (error) {
        showToast('Unable to add this item right now.', true);
      } finally {
        submitButton?.removeAttribute('aria-busy');
      }
    }
    productForm?.addEventListener('submit', addToCart);
    $('[data-sr-mobile-buy]')?.addEventListener('click', function () { productForm?.requestSubmit(); });

    function openLightbox() {
      if (!lightbox) return;
      lightbox.classList.add('is-visible');
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('lefy-soundrest-locked');
    }
    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('is-visible');
      lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('lefy-soundrest-locked');
    }
    $('[data-sr-gallery-expand]')?.addEventListener('click', openLightbox);
    $('[data-sr-lightbox-close]')?.addEventListener('click', closeLightbox);
    lightbox?.addEventListener('click', function (event) { if (event.target === lightbox) closeLightbox(); });

    const revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); }
      });
    }, { threshold: 0.12 });
    doc$$('.sr-reveal').forEach(function (element) { revealObserver.observe(element); });
    root.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeLightbox(); });
    doc$('[data-sr-mode]') && setMode(doc$('[data-sr-mode]').dataset.srMode || 'Sleep', true);
  }

  function revealEditorSection(container) {
    if (!window.Shopify || !window.Shopify.designMode || !container) return;
    const sections = [];
    if (container.matches && container.matches('.lefy-soundrest-page')) sections.push(container);
    if (container.querySelectorAll) container.querySelectorAll('.lefy-soundrest-page').forEach(function (section) { sections.push(section); });
    sections.forEach(function (section) {
      section.querySelectorAll('.sr-reveal').forEach(function (element) { element.classList.add('is-visible'); });
    });
  }

  function boot() {
    document.querySelectorAll('[data-lefy-soundrest]').forEach(init);
    document.querySelectorAll('[data-sr-product-nav]').forEach(initNavigation);
    revealEditorSection(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', function (event) {
    revealEditorSection(event.target);
    boot();
  });
  document.addEventListener('shopify:section:select', function (event) { revealEditorSection(event.target); });
  document.addEventListener('shopify:block:select', function (event) { revealEditorSection(event.target); });
})();
